module.exports = __webpack_public_path__ + "static/media/3-ball.d2d0a266.png";